<table class="table table-responsive align-middle" [attr.id]="'' + refid" [ngClass]="custom">
  <thead>
  <tr>
    <ng-content *ngTemplateOutlet="headerTemplate"></ng-content>
  </tr>
  </thead>
  <tbody class="">
  <ng-container *ngFor="let item of items; let id = index">
    <tr>
      <ng-content *ngTemplateOutlet="firstTemplate; context: { $implicit: item, index: id }"></ng-content>
    </tr>
    <tr>
      <td [attr.colspan]="colspan">
        <ng-content *ngTemplateOutlet="secondTemplate; context: { $implicit: item, index: id }"></ng-content>
      </td>
    </tr>
    <tr class="border-bottom border-1"></tr>
  </ng-container>
  </tbody>
</table>

